import React from 'react';
import './index.scss';
import CategoryTable from './children/CategoryTable';
import { DEVELOPMENT_CONTENTS, HEADER_TEXT, STRENGTH_CONTENTS } from './constants';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import SectionHeader from '../../../SectionHeader';

const KeyTakeAway = (props) => {
    const strengthsData = props.fetchTopStrengthAndTopDevApi.data && props.fetchTopStrengthAndTopDevApi.data.strengthsData ? props.fetchTopStrengthAndTopDevApi.data.strengthsData : []
    const developmentAreasData = props.fetchTopStrengthAndTopDevApi.data && props.fetchTopStrengthAndTopDevApi.data.developmentAreasData ? props.fetchTopStrengthAndTopDevApi.data.developmentAreasData : []
    return (
        <AsyncSection api={props.fetchTopStrengthAndTopDevApi} loaderHeight={300} loaderWidth={600}>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />

            <div className='cardwrapper'>
                <div className="keytakeaway-container">
                    {strengthsData.length != 0 && <CategoryTable data={strengthsData} contents={STRENGTH_CONTENTS} />}
                    {developmentAreasData.length != 0 && <CategoryTable data={developmentAreasData} contents={DEVELOPMENT_CONTENTS} />}
                </div>
            </div>
        </AsyncSection>
    );
};

export default KeyTakeAway;
